(() => {
  'use strict';
  const start = () => {
    const root = document.querySelector('[data-amnl-root]');
    if (!root || root.dataset.amnlInitialized === 'true') return;
    root.dataset.amnlInitialized = 'true';
    const popup = root.querySelector('[data-amnl-overlay]');
    const dialog = root.querySelector('[data-amnl-dialog]');
    const close = root.querySelector('[data-amnl-close]');
    const signup = root.querySelector('#amnl-inline');
    const signupParent = signup?.parentNode;
    const signupNext = signup?.nextSibling;
    const popupSlot = root.querySelector('[data-amnl-form-slot]');
    const returnSignup = () => {
      if (signup && signupParent && signup.parentNode !== signupParent) signupParent.insertBefore(signup, signupNext);
    };
    const storageKey = 'amnl-rider-club-20261103';
    const localKey = storageKey + '-frequency';
    const readSession = () => {
      try { const value = sessionStorage.getItem(storageKey); if (value) return value; } catch (_) {}
      try { const saved = JSON.parse(localStorage.getItem(localKey) || 'null'); if (saved && Number(saved.until) > Date.now()) return saved.reason || 'dismissed'; } catch (_) {}
      return null;
    };
    const writeSession = value => {
      try { sessionStorage.setItem(storageKey, value); } catch (_) {}
      const hours = value === 'dismissed' ? 48 : value === 'confirmed' ? 24 * 30 : 0;
      if (hours) { try { localStorage.setItem(localKey, JSON.stringify({ reason: value, until: Date.now() + hours * 60 * 60 * 1000 })); } catch (_) {} }
    };
    let lastFocus = null;
    let opened = false;
    const hasBlockingDialog = () => {
      const selectors = ['#shopify-pc__banner','.shopify-pc__banner','[data-consent-banner]:not([hidden])','[role="dialog"][aria-modal="true"]:not(.amnl-modal)'];
      return selectors.some(s => [...document.querySelectorAll(s)].some(e => e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden'));
    };
    function dismiss() {
      if (!popup || popup.hidden) return;
      popup.hidden = true;
      returnSignup();
      document.documentElement.style.removeProperty('overflow');
      writeSession('dismissed');
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }
    function show() {
      if (!popup || opened || !popup.hidden || readSession()) return;
      if (document.visibilityState !== 'visible' || hasBlockingDialog()) return;
      opened = true;
      lastFocus = document.activeElement;
      if (signup && popupSlot) popupSlot.appendChild(signup);
      popup.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      dialog?.focus({ preventScroll: true });
      const input = popup.querySelector('input[type=email]');
      setTimeout(() => input?.focus({ preventScroll: true }), 80);
    }
    document.querySelectorAll('.amnl-signup').forEach(form => {
      form.addEventListener('submit', e => {
        if (!form.checkValidity()) return;
        writeSession('submitted');
      }, { passive: true });
    });
    if (!popup || root.dataset.popupEnabled !== 'true') return;
    close?.addEventListener('click', dismiss);
    popup.addEventListener('click', e => { if (e.target === popup) dismiss(); });
    document.addEventListener('keydown', e => {
      if (popup.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); dismiss(); }
      if (e.key === 'Tab') {
        const els = [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.getClientRects().length);
        if (!els.length) return;
        const first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    if (root.querySelector('.amnl-message--success')) writeSession('confirmed');
    if (readSession() || document.querySelector('input[name="customer_posted"]')) return;
    const delay = Math.max(5000, Math.min(35000, (Number(root.dataset.popupDelay) || 12) * 1000));
    // Do not obscure an active checkout, consent notice or customer typing.
    let attempts = 0;
    const tryAfterConsent = () => {
      if (readSession() || opened) return;
      if (hasBlockingDialog() || document.activeElement?.matches?.('input,textarea,[contenteditable=true]')) {
        if (++attempts <= 25) setTimeout(tryAfterConsent, 4000);
        return;
      }
      show();
    };
    setTimeout(tryAfterConsent, delay);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();